/**
 * NEIWAI Custom Theme Interactivity
 */

document.addEventListener('DOMContentLoaded', initThemeScripts);

/**
 * Testimonials Slider Logic
 */
function initTestimonials() {
  const sliders = document.querySelectorAll('[data-neiwai-slider="testimonials"]');
  
  sliders.forEach(slider => {
    if (!(slider instanceof HTMLElement)) return;
    
    const slides = slider.querySelectorAll('.neiwai-testimonials__slide');
    const prevBtn = slider.querySelector('.prev');
    const nextBtn = slider.querySelector('.next');
    const currentSpan = slider.querySelector('.neiwai-testimonials__current');
    
    if (slides.length === 0) return;

    let currentIndex = 0;
    const total = slides.length;
    
    const updateSlider = (/** @type {number} */ newIndex) => {
      const currentSlide = slides[currentIndex];
      if (currentSlide instanceof HTMLElement) {
        currentSlide.classList.remove('is-active');
      }
      
      currentIndex = (newIndex + total) % total;
      
      const nextSlide = slides[currentIndex];
      if (nextSlide instanceof HTMLElement) {
        nextSlide.classList.add('is-active');
      }
      
      if (currentSpan) {
        currentSpan.textContent = (currentIndex + 1).toString().padStart(2, '0');
      }
    };
    
    if (prevBtn) prevBtn.addEventListener('click', () => updateSlider(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => updateSlider(currentIndex + 1));
    
    // Autoplay
    const autoplay = slider.dataset.autoplay === 'true';
    if (autoplay) {
      const interval = parseInt(slider.dataset.interval || '5') * 1000;
      setInterval(() => updateSlider(currentIndex + 1), interval);
    }
  });
}

/**
 * Product Gallery Thumbnail Logic (Pills style)
 */
function initProductGallery() {
  const thumbnailWrappers = document.querySelectorAll('.neiwai-product-main__thumbnails');
  
  thumbnailWrappers.forEach(wrapper => {
    const mainSection = wrapper.closest('.neiwai-product-main');
    if (!mainSection) return;

    const thumbnails = wrapper.querySelectorAll('.neiwai-product-main__thumbnail');
    const mainImages = mainSection.querySelectorAll('.neiwai-product-main__media-item');
    
    thumbnails.forEach(thumb => {
      if (!(thumb instanceof HTMLElement)) return;
      
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.mediaId;
        
        // Update active thumb
        thumbnails.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        
        // Update active main image
        mainImages.forEach(img => {
          if (!(img instanceof HTMLElement)) return;
          if (img.dataset.mediaId === mediaId) {
            img.classList.add('is-active');
          } else {
            img.classList.remove('is-active');
          }
        });
      });
    });
  });
}

/**
 * Dynamic Header Transparency Toggle
 */
function initHeaderTransparency() {
  const header = document.querySelector('#header-component');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 50) {
      header.classList.add('is-scrolled');
      document.body.classList.add('header-is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
      document.body.classList.remove('header-is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
}

/**
 * AJAX Newsletter Integration
 */
function initNewsletter() {
  const form = document.querySelector('#neiwai-newsletter-form');
  if (!form || !(form instanceof HTMLFormElement)) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const emailInput = form.querySelector('input[name="email"]');
    if (!(emailInput instanceof HTMLInputElement)) return;
    
    const email = emailInput.value;
    const listId = form.dataset.klaviyoListId;
    const messageEl = form.querySelector('.neiwai-newsletter__message');
    if (!(messageEl instanceof HTMLElement)) return;

    // Display "sending" state
    messageEl.textContent = "Joining our world...";
    messageEl.className = "neiwai-newsletter__message";
    messageEl.style.display = "block";

    // Simulating Klaviyo / Shopify form submit
    setTimeout(() => {
      messageEl.textContent = "Thank you. You details have been captured.";
      messageEl.className = "neiwai-newsletter__message success";
      form.reset();
    }, 1000);
  });
}

let cartUpsellObserver;

function initCartUpsellItems() {
  document.querySelectorAll('.cart-upsell__item').forEach((item) => {
    if (item.dataset.upsellInitialized === 'true') return;
    item.dataset.upsellInitialized = 'true';

    const jsonScript = item.querySelector('.cart-upsell__variants-json');
    if (!jsonScript) return;

    const variants = JSON.parse(jsonScript.textContent);
    const colorOptionIdx = parseInt(item.dataset.colorOptionIndex ?? '-1', 10);
    const sizeOptionIdx = parseInt(item.dataset.sizeOptionIndex ?? '-1', 10);

    const variantIdInput = item.querySelector('input[name="id"]');
    const priceElement = item.querySelector('.cart-upsell__price');
    const img = item.querySelector('.cart-upsell__media-wrapper img');
    const button = item.querySelector('.cart-upsell__button');
    const buttonText = item.querySelector('.cart-upsell__button .add-to-cart-text');

    const formatMoney = (cents) => {
      const dollars = cents / 100;
      return dollars % 1 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`;
    };

    const findVariant = (selectedColor, selectedSize) => {
      return variants.find((v) => {
        const colorMatch = colorOptionIdx < 0 || selectedColor == null || v.options[colorOptionIdx] === selectedColor;
        const sizeMatch = sizeOptionIdx < 0 || selectedSize == null || v.options[sizeOptionIdx] === selectedSize;
        return colorMatch && sizeMatch;
      });
    };

    const updateCardState = (triggerIsColor) => {
      const checkedColorInput = item.querySelector('input[name*="-swatch"]:checked');
      const checkedSizeInput = item.querySelector('input[name*="-size"]:checked');

      const selectedColor = checkedColorInput ? checkedColorInput.value : null;
      const selectedSize = checkedSizeInput ? checkedSizeInput.value : null;

      if (triggerIsColor && checkedColorInput) {
        const mediaSrc = checkedColorInput.dataset.optionMediaSrc;
        if (img && mediaSrc) {
          img.src = mediaSrc;
          img.srcset = '';
        }
      }

      if (selectedColor && sizeOptionIdx >= 0 && colorOptionIdx >= 0) {
        const sizeInputs = item.querySelectorAll('input[name*="-size"]');
        sizeInputs.forEach((sizeInput) => {
          const sizeValue = sizeInput.value;
          const matchingVar = variants.find((v) => v.options[colorOptionIdx] === selectedColor && v.options[sizeOptionIdx] === sizeValue);
          const label = item.querySelector(`label[for="${sizeInput.id}"]`);
          const isAvailable = !!(matchingVar && matchingVar.available);
          if (label) label.classList.toggle('is-unavailable', !isAvailable);
          sizeInput.dataset.optionAvailable = isAvailable ? 'true' : 'false';
        });
      }

      let matchingVariant = findVariant(selectedColor, selectedSize);
      if (!matchingVariant && selectedColor) {
        matchingVariant = variants.find((v) => v.options[colorOptionIdx] === selectedColor && v.available);
        if (!matchingVariant) matchingVariant = variants.find((v) => v.options[colorOptionIdx] === selectedColor);
      }

      if (matchingVariant) {
        if (variantIdInput) variantIdInput.value = matchingVariant.id;
        if (priceElement) priceElement.textContent = formatMoney(matchingVariant.price);
        if (!triggerIsColor && img && matchingVariant.featured_image && matchingVariant.featured_image.src) {
          img.src = matchingVariant.featured_image.src;
          img.srcset = '';
        }
        if (button && buttonText) {
          if (matchingVariant.available) {
            button.disabled = false;
            buttonText.textContent = 'Add to Cart';
          } else {
            button.disabled = true;
            buttonText.textContent = 'Sold Out';
          }
        }
      } else if (button && buttonText) {
        button.disabled = true;
        buttonText.textContent = 'Unavailable';
      }
    };

    item.addEventListener('change', (event) => {
      if (!event.target || !(event.target instanceof HTMLInputElement)) return;
      const name = event.target.name || '';
      const isColor = name.includes('-swatch');
      const isSize = name.includes('-size');
      if (isColor || isSize) {
        updateCardState(isColor);
      }
    });

    const form = item.querySelector('form');
    if (form) {
      form.addEventListener('submit', (event) => {
        try {
          const checkedColorInput = item.querySelector('input[name*="-swatch"]:checked');
          const checkedSizeInput = item.querySelector('input[name*="-size"]:checked');
          const selectedColor = checkedColorInput ? checkedColorInput.value : null;
          const selectedSize = checkedSizeInput ? checkedSizeInput.value : null;
          const matching = findVariant(selectedColor, selectedSize);
          if (matching && variantIdInput) {
            variantIdInput.value = matching.id;
          }
        } catch (error) {
          // ignore
        }
      }, true);
    }

    updateCardState(false);
  });
}

function watchCartUpsellItems() {
  if (cartUpsellObserver) return;

  cartUpsellObserver = new MutationObserver((mutations) => {
    const shouldInit = mutations.some((mutation) => {
      return Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element || node instanceof DocumentFragment)) return false;
        return (
          (node instanceof Element && node.matches('.cart-upsell__item')) ||
          node.querySelector('.cart-upsell__item')
        );
      });
    });

    if (shouldInit) {
      initCartUpsellItems();
    }
  });

  cartUpsellObserver.observe(document.body, { childList: true, subtree: true });
}

function initThemeScripts() {
  initTestimonials();
  initProductGallery();
  initHeaderTransparency();
  initNewsletter();
  initCartUpsellItems();
  watchCartUpsellItems();
}

document.addEventListener('DOMContentLoaded', initThemeScripts);
window.addEventListener('load', () => setTimeout(initCartUpsellItems, 200));
document.addEventListener('shopify:section:load', () => setTimeout(initCartUpsellItems, 100));
document.addEventListener('dialog:open', () => setTimeout(initCartUpsellItems, 100));
document.addEventListener('cart:update', () => setTimeout(initCartUpsellItems, 100));
document.addEventListener('cart:updated', () => setTimeout(initCartUpsellItems, 100));
window.initCartUpsellItems = initCartUpsellItems;
